import React from 'react';
import {connect} from 'react-redux';

import * as ScoreType from 'constants/ScoreType';
import * as MatchScoreType from 'constants/MatchScore';

import MatchScoresAdapter from '../../adapters/MatchScoresAdapter';
import FlashScore from './FlashScore.jsx';

class MatchScores extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        groupId: React.PropTypes.number,
        gridLocalization: React.PropTypes.object.isRequired,
        groupScores: React.PropTypes.array
    };

    static renderScore(score) {
        const scoreType = score.get('type');

        if (scoreType === ScoreType.CurrentGame) {
            return MatchScores.renderTennisGameScore(score);
        }

        return MatchScores.renderRegularScore(score);
    }

    static renderFoulsScore(score, foulsText) {
        const score1 = score.get('score1') || 0;
        const score2 = score.get('score2') || 0;

        return `${foulsText} ${score1}:${score2}`;
    }

    static renderRegularScore(score) {
        const score1 = score.get('score1') || 0;
        const score2 = score.get('score2') || 0;

        return score1 + ':' + score2;
    }

    static renderScoreWithPossession(score, possession) {
        const score1 = score.get('score1') || 0;
        const score2 = score.get('score2') || 0;

        if (possession === 1) {
            return `*${score1}:${score2}`;
        } else if (possession === 2) {
            return `${score1}:${score2}*`;
        }

        return `${score1}:${score2}`;
    }

    static renderScoreWithPowerPlay(score, powerplay) {
        const score1 = score.get('score1') || 0;
        const score2 = score.get('score2') || 0;

        if (powerplay === 1) {
            return `PP ${score1}:${score2}`;
        } else if (powerplay === 2) {
            return `${score1}:${score2} PP`;
        }

        return `${score1}:${score2}`;
    }

    static renderTennisGameScore(score) {
        const team = score.get('team');
        let score1 = score.get('score1') || 0;
        let score2 = score.get('score2') || 0;

        score1 = score1 === 100 ? 'A' : score1;
        score2 = score2 === 100 ? 'A' : score2;

        let result = score1 + ':' + score2;

        if (team !== null) {

            if (team === 1) {
                result = '*' + result;
            } else if (team === 2) {
                result = result + '*';
            }
        }

        return result;
    }

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization.languageId !== nextProps.gridLocalization.languageId ||
            this.props.groupScores !== nextProps.groupScores;
    }

    render() {
        const {groupId, groupScores, gridLocalization} = this.props;

        if (groupScores === undefined || groupScores.length === 0) {
            return false;
        }

        let scoreString = '';
        for (let i = 0; i < groupScores.length; i++) {
            const matchScore = groupScores[i];

            switch (matchScore.type) {
                case MatchScoreType.MAIN:
                    if (scoreString.length > 0) {
                        scoreString += ' ';
                    }
                    if (matchScore.possession !== undefined) {
                        scoreString += MatchScores.renderScoreWithPossession(matchScore.value, matchScore.possession);
                    } else if (matchScore.powerplay !== undefined) {
                        scoreString += MatchScores.renderScoreWithPowerPlay(matchScore.value, matchScore.powerplay);
                    } else {
                        scoreString += MatchScores.renderScore(matchScore.value);
                    }
                    break;
                case MatchScoreType.INFO:
                    if (scoreString.length > 0) {
                        scoreString += ' ';
                    }
                    scoreString += gridLocalization.getMatchInfoText(matchScore.value);
                    break;
                case MatchScoreType.PERIOD_INFO:
                    if (scoreString.length > 0) {
                        scoreString += ' ';
                    }
                    scoreString += gridLocalization.getPeriodName(matchScore.sportId, matchScore.periodId);
                    break;
                case MatchScoreType.ADDITIONAL:
                    scoreString += ' (';
                    matchScore.value.forEach(m => scoreString += MatchScores.renderScore(m) + ' ');
                    scoreString = scoreString.trim();
                    scoreString += ')';
                    break;
                case MatchScoreType.CURRENT_GAME:
                    scoreString += ' ' + MatchScores.renderScore(matchScore.value);
                    break;
                case MatchScoreType.OVERTIME:
                    scoreString += ' (' + MatchScores.renderScore(matchScore.value) + ')';
                    break;
                case MatchScoreType.FOULS: {
                    const foulsText = gridLocalization.getFoulsText();
                    scoreString += ' ' + MatchScores.renderFoulsScore(matchScore.value, foulsText);
                }
            }
        }

        return (<FlashScore key={groupId} scoreString={scoreString} languageId={gridLocalization.languageId} />);
    }
}

function select(state, props) {
    const {section, matchId, groupId, gridLocalization} = props;
    const match = state.application.getIn([section, 'matches', matchId]);
    const group = state.application.getIn([section, 'groups', groupId]);
    const scores = state.application.getIn([section, 'scores']);

    let groupScores;
    let groupTypeId = group ? group.get('type') : 0;

    if (match) {
        groupScores = MatchScoresAdapter.getGroupScores(match, groupTypeId, scores);
    }

    return {
        groupId,
        groupScores,
        gridLocalization
    };
}

export default connect(select, null, null, false)(MatchScores);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/matchStats/MatchScores.jsx